module.exports = () => {
	return new Promise((resolve) => {
		return resolve(navigator.language || 'en-US');
	});
};
